import logo from './logo.svg';
import './App.css';
import Headers from './Components/Header';
import Home from './Pages/Home';
import Footers from './Components/Footer';
import { BrowserRouter } from 'react-router-dom';
import { Layout } from 'antd';


function App() {
  return (
    <Layout>
    <BrowserRouter>
    <div className="App">
       <Home/>
    </div>
    </BrowserRouter>
    </Layout>
  );
}

export default App;

